/* eslint-disable no-shadow */
import { clevertapEvent } from 'utils/clevertap';

const PAYWALL = 'Paywall Action';

const ACTION = {
  openAccess: 'Paywall Open Access Selected',
  extendSubscribe: 'Paywall Extend Subscribe Selected',
  openSecurities: 'Paywall Open Securities Selected',
  openSubscribe: 'Paywall Subscribe Selected',
  paymentSelected: 'Paywall Payment Method Selected',
  inputVoucher: 'Paywall Input Voucher Selected',
  confirmPayment: 'Paywall Payment Confirmation  Selected',
  selectPlan: 'Paywall Subscribe Plan Selected',
  confirmSubscribe: 'Paywall Subscribe Confirmation Selected',
  submitVoucher: 'Paywall Submit Voucher Selected',
  successSubscribe: 'Paywall Subscribe Success Selected',
};

export enum SideWidgetAnalytics {
  PRICE_ALERT = 'Price Alert (Side Bar)',
  RUNNING_TRADE = 'Running Trade (Side Bar)',
  VALUATION = 'Valuation (Side Bar)',
  SCREENER = 'Screener (Side Bar)',
  BANDAR_DETECTOR = 'Bandar Detector (Side Bar)',
}

export enum PageAnalytics {
  ORDERBOOK = 'Orderbook (Top Bar)',
  SCREENER = 'Screener (Top Bar)',
  VALUATION = 'Valuation (Top Bar)',
  CALENDAR = 'Calendar (Top Bar)',
  EARNINGS = 'Earnings (Top Bar)',
  CHARTBIT = 'Chartbit (Top Bar)',
}

export enum CompanyAnalytics {
  ORDERBOOK = 'Orderbook (Company)',
  RUNNING_TRADE = 'Running Trade (Company)',
  KEYSTATS = 'Keystats (Company)',
  ANALYST = 'Analysis (Company)',
  FINANCIALS = 'Financials (Company)',
  FUNDACHART = 'Fundachart (Company)',
  SEASONALITY = 'Seasonality (Company)',
  CHARTBIT = 'Chartbit (Company)',
  COMPARISON = 'Comparison (Company)',
  INSIDER = 'Insider (Company)',
  PROFILE = 'Company Profile (Company)',
  CORPACTION = 'Corporate Action (Company)',
}

export const CompanyWidgetAnalytics = {
  Orderbook: 'Orderbook (Company)',
  'Running Trade': 'Running Trade (Company)',
  'Trade Book': 'Trade Book (Company)',
  'Broker Summary': 'Broker Summary (Company)',
};

enum PaymentMethod {
  bca_va = 'BCA',
  veritrans = 'Credit Card',
  gopay = 'Gopay',
}

type SubscriptionType = '1 Hari' | '1 Bulan' | '6 Bulan' | '1 Tahun' | string;

function formatDuration(durationString: string) {
  const duration = parseInt(durationString, 10);

  if (Number.isNaN(duration)) {
    return durationString;
  }

  if (durationString.includes('MONTH')) {
    return `${duration} Bulan`;
  }
  if (durationString.includes('YEAR')) {
    return `${duration} Tahun`;
  }
  if (durationString.includes('DAY')) {
    return `${duration} Hari`;
  }
  return durationString;
}

interface PaywallEventParams {
  action?: string;
  oldStatus: boolean;
  source: string;
  companyID: string;
}

const createPaywallEvent = (action: string, params: PaywallEventParams): void => {
  const { oldStatus, source, companyID } = params;
  clevertapEvent(PAYWALL, {
    Action: action,
    'Old Subscriber Pro': oldStatus,
    Source: source,
    'Company ID': companyID,
  });
};

const PaywallAnalytics = {
  onClickOpenAccess: (params: PaywallEventParams): void => {
    createPaywallEvent(ACTION.openAccess, { ...params });
  },
  onClickExtendSubscribe: (params: PaywallEventParams): void => {
    createPaywallEvent(ACTION.extendSubscribe, { ...params });
  },
  onClickOpenSecurities: (): void => {
    clevertapEvent(PAYWALL, {
      Action: ACTION.openSecurities,
    });
  },
  onClickOpenSubscribe: (): void => {
    clevertapEvent(PAYWALL, {
      Action: ACTION.openSubscribe,
    });
  },
  onClickPaymentSelected: (paymentMethod: string): void => {
    clevertapEvent(PAYWALL, {
      Action: ACTION.paymentSelected,
      'Metode Pembayaran': PaymentMethod[paymentMethod],
    });
  },
  onClickInputVoucher: (): void => {
    clevertapEvent(PAYWALL, {
      Action: ACTION.inputVoucher,
    });
  },
  onClickConfirmPayment: (): void => {
    clevertapEvent(PAYWALL, {
      Action: ACTION.confirmPayment,
    });
  },
  onClickSelectPlan: (plan: SubscriptionType): void => {
    clevertapEvent(PAYWALL, {
      Action: ACTION.selectPlan,
      'Subscription Period': formatDuration(plan),
    });
  },
  onClickConfirmSubscribe: (): void => {
    clevertapEvent(PAYWALL, {
      Action: ACTION.confirmSubscribe,
    });
  },
  onClickSubmitVoucher: (voucher: string): void => {
    clevertapEvent(PAYWALL, {
      Action: ACTION.submitVoucher,
      Voucher: voucher,
    });
  },
  onClickSuccessSubscribe: (): void => {
    clevertapEvent(PAYWALL, {
      Action: ACTION.successSubscribe,
    });
  },
};

export default PaywallAnalytics;
